import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres83e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres83e/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    let dtereserv = ''
    if (typeof searchParams !== 'undefined') {
      dtereserv = (typeof searchParams.dtereserv.replace(/\//g, '') !== 'undefined' ? searchParams.dtereserv.replace(/\//g, '') : '')
      sendParams = {
        p_typasset: (typeof searchParams.codasset !== 'undefined' ? searchParams.codasset : ''),
        p_timstrt: (typeof searchParams.timstrt !== 'undefined' ? searchParams.timstrt : ''),
        p_timend: (typeof searchParams.timend !== 'undefined' ? searchParams.timend : '')
      }
    }
    return instance().get(endpoint + '/hres83e/index/' + dtereserv, { params: sendParams })
  },
  getAssetDetail (searchParams) {
    if (isMock) return generator(mocker.assetDetail())
    const params = searchParams.assetno
    return instance().get(endpoint + '/hres83e/assetDetail/' + params)
  },
  getCalendar (searchParams) {
    if (isMock) return generator(mocker.calendar())
    let assetno = ''
    let dtemonth = ''
    let dteyear = ''
    if (typeof searchParams !== 'undefined') {
      assetno = (typeof searchParams.assetno !== 'undefined' ? searchParams.assetno : '')
      dtemonth = (typeof searchParams.dtemonth !== 'undefined' ? searchParams.dtemonth : '')
      dteyear = (typeof searchParams.dteyear !== 'undefined' ? searchParams.dteyear : '')
    }
    return instance().get(endpoint + '/hres83e/calendar/' + assetno + '/' + dtemonth + '/' + dteyear)
  },
  getCalendarDetail (searchParams) {
    if (isMock) return generator(mocker.calendarDetail())
    let assetno = ''
    let dtereserv = ''
    if (typeof searchParams !== 'undefined') {
      assetno = (typeof searchParams.assetno !== 'undefined' ? searchParams.assetno : '')
      dtereserv = (typeof searchParams.dtereserv.replace(/\//g, '') !== 'undefined' ? searchParams.dtereserv.replace(/\//g, '') : '')
    }
    return instance().get(endpoint + '/hres83e/calendarDetail/' + assetno + '/' + dtereserv)
  },
  // getReserveCreate (searchParams) {
  //   if (isMock) return generator(mocker.reserveCreate())
  //   let assetno = ''
  //   let dtereserv = ''
  //   if (typeof searchParams !== 'undefined') {
  //     assetno = (typeof searchParams.assetno !== 'undefined' ? searchParams.assetno : '')
  //     dtereserv = (typeof searchParams.dtereserv.replace(/\//g, '') !== 'undefined' ? searchParams.dtereserv.replace(/\//g, '') : '')
  //   }
  //   return instance().get(endpoint + '/hres83e/reserveCreate/' + assetno + '/' + dtereserv)
  // },
  getReserveDetail (searchParams) {
    if (isMock) return generator(mocker.reserveDetail())
    let assetno = ''
    let dtereserv = ''
    let seqno = ''
    if (typeof searchParams !== 'undefined') {
      assetno = (typeof searchParams.assetno !== 'undefined' ? searchParams.assetno : '')
      dtereserv = (typeof searchParams.dtereserv.replace(/\//g, '') !== 'undefined' ? searchParams.dtereserv.replace(/\//g, '') : '')
      seqno = (typeof searchParams.seqno !== 'undefined' ? searchParams.seqno : '')
    }
    return instance().get(endpoint + '/hres83e/reserveDetail/' + assetno + '/' + dtereserv + '/' + seqno)
  },
  postReserveCancel (cancelParams) {
    if (isMock) return generator(mocker.reserveCancel())
    return instance().post(endpoint + '/hres83e/reserveCancel', cancelParams)
  },
  postReserveSave (saveParams) {
    if (isMock) return generator(mocker.reserveSave())
    return instance().post(endpoint + '/hres83e/reserveDetailSave', saveParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres83e/index.js